/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { paginationStyle, pageButtonStyle } from './Pagination.styles';

export interface PaginationProps {
  /** 현재 범위 문구. 예: "1–50" */
  rangeLabel: ReactNode;
  /** 전체 건수 문구. 예: "128,540 rows" (선택) */
  totalLabel?: ReactNode;
  onPrev?: () => void;
  onNext?: () => void;
}

/** 앞/뒤 페이지 이동. 데이터 브라우저 상단 행 탐색에 활용. */
export function Pagination({ rangeLabel, totalLabel, onPrev, onNext }: PaginationProps) {
  return (
    <span css={paginationStyle}>
      {totalLabel !== undefined && <span>{totalLabel}</span>}
      <button type="button" css={pageButtonStyle} aria-label="previous page" onClick={onPrev}>
        ‹
      </button>
      <span>{rangeLabel}</span>
      <button type="button" css={pageButtonStyle} aria-label="next page" onClick={onNext}>
        ›
      </button>
    </span>
  );
}
